import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './blogs.css';

const MarkdownImage = ({ alt, src }) => {
    // ensure absolute path for images stored under /upload/data/images/blogs
    const resolvedSrc = src && (src.startsWith('/') ? src : `/upload/data/images/blogs/${src}`);
    return <img src={resolvedSrc} alt={alt} loading="lazy" style={{ maxWidth: '100%' }} />;
};

const BlogDetail = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                setLoading(true);
                const response = await fetch('/upload/data/blogs.json');
                const blogs = await response.json();

                // Find local blog by slug (external blogs won't have slug)
                const found = blogs.find((p) => p.type === 'local' && (p.slug === slug || p.id === slug));
                setPost(found || null);
            } catch (err) {
                console.error('Failed to load blog detail:', err);
                setPost(null);
            } finally {
                setLoading(false);
            }
        };

        fetchBlog();
    }, [slug]);

    if (loading) {
        return (
            <div className="blog-detail-page-3d">
                <div className="blog-detail-container-3d">
                    <p>Loading...</p>
                    <Link to="/blogs">Back to Blogs</Link>
                </div>
            </div>
        );
    }

    if (!post) {
        return (
            <div className="blog-detail-page-3d">
                <div className="blog-detail-container-3d">
                    <p>Post not found.</p>
                    <Link to="/blogs">Back to Blogs</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="blog-detail-page-3d">
            <div className="blog-detail-container-3d">
                <Link to="/blogs" className="back-link-3d">← Back to Blogs</Link>
                <h1 className="blog-detail-title-3d">{post.title}</h1>
                <div className="blog-detail-meta-3d">By {post.author?.name} · {new Date(post.date).toLocaleDateString()} · {post.readTimeMinutes} min read</div>
                {post.thumbnail && <img src={post.thumbnail} alt={`${post.title} thumbnail`} className="blog-detail-thumbnail-3d" />}
                {post.image ? (
                    <img src={post.image} alt={post.title} className="blog-detail-image-3d" />
                ) : (
                    post.coverImage && <img src={post.coverImage} alt={post.title} className="blog-detail-image-3d" />
                )}

                <div className="blog-detail-content-3d">
                    <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                            img: ({ node, ...props }) => <MarkdownImage {...props} />
                        }}
                    >
                        {post.content}
                    </ReactMarkdown>
                </div>
            </div>
        </div>
    );
};

export default BlogDetail;
